import { render, staticRenderFns } from "./AssessmentWizardOverlay.vue?vue&type=template&id=0873f6ab&scoped=true"
import script from "./AssessmentWizardOverlay.vue?vue&type=script&lang=js"
export * from "./AssessmentWizardOverlay.vue?vue&type=script&lang=js"
import style0 from "./AssessmentWizardOverlay.vue?vue&type=style&index=0&id=0873f6ab&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0873f6ab",
  null
  
)

export default component.exports